export default "__VITE_PUBLIC_ASSET__d13b8b02__"